'use client';

// file imports
import { IQuestion } from '@/types';

interface QuestionNavigationProps {
  selectedQuestion: IQuestion | null;
  orderedQuestions: IQuestion[];
  onNavigate: (question: IQuestion) => void;
  showSaveButton?: boolean;
}

export default function QuestionNavigation({ selectedQuestion, orderedQuestions, onNavigate, showSaveButton = true }: QuestionNavigationProps) {
  if (!showSaveButton) return null;

  const currentIndex = selectedQuestion ? orderedQuestions.findIndex((q) => q._id === selectedQuestion._id) : -1;
  const isFirstQuestion = currentIndex === 0;
  const isLastQuestion = currentIndex === orderedQuestions.length - 1;

  const handlePrevious = () => {
    if (currentIndex > 0) {
      const prevQuestion = orderedQuestions[currentIndex - 1];
      onNavigate(prevQuestion);
    }
  };

  const handleNext = () => {
    if (currentIndex < orderedQuestions.length - 1) {
      const nextQuestion = orderedQuestions[currentIndex + 1];
      onNavigate(nextQuestion);
    }
  };

  return (
    <div className="mt-4 sm:mt-6 flex justify-between items-center">
      <button onClick={handlePrevious} disabled={!selectedQuestion || isFirstQuestion} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-colors">
        <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      <button onClick={handleNext} disabled={!selectedQuestion || isLastQuestion} className="flex items-center gap-1 sm:gap-2 px-3 sm:px-6 py-1.5 sm:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-colors font-medium text-xs sm:text-sm">
        Next
        <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
